// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"763":"8639ac26","2085":"8639ac26","4494":"8639ac26","7240":"8539a311","7497":"8639ac26"}[chunkId] + ".chunk.css";
};